import * as React from 'react'

import { FormattedMessage } from 'react-intl'
import { Button }           from '../../atoms'

export default (props: any) => {
  const phrasing = {
    save: <FormattedMessage id={'buttonActions.save'} />,
  }

  const { children, fetching, ...rest } = props

  return (
    <form onSubmit={props.handleSubmit}>
      {children(rest)}
      <div style={{ padding: '24px 0 0 0' }}>
        <Button
          displayLoader={fetching}
          type={'submit'}
          color={'secondary'}
          variant={'raised'}
        >
          {phrasing.save}
        </Button>
      </div>
    </form>
  )
}



// WEBPACK FOOTER //
// ./src/components/forms/wrappers/SimpleSubmitFormWrapper.tsx